// extracted by mini-css-extract-plugin
export var bracket = "ProcessOfWorkItem-module--bracket--pSjeL";
export var container = "ProcessOfWorkItem-module--container--zYIXw";
export var counter = "ProcessOfWorkItem-module--counter--VgWGr";
export var wrapper = "ProcessOfWorkItem-module--wrapper--+TF+Z";
export var wrapper__description = "ProcessOfWorkItem-module--wrapper__description--SI0Er";
export var wrapper__id = "ProcessOfWorkItem-module--wrapper__id--2Vvnr";
export var wrapper__text = "ProcessOfWorkItem-module--wrapper__text--FV-9m";